import { Link } from 'react-router-dom';

const footerLinks = {
  solutions: [
    { label: 'Processing', href: '/processing' },
    { label: 'Storage', href: '/storage' },
    { label: 'Transport', href: '/transport' },
    { label: 'Wholesale', href: '/wholesale' },
    { label: 'Retail', href: '/retail' },
    { label: 'Platform Overview', href: '/' },
  ],
  company: [
    { label: 'About Us', href: '/company' },
    { label: 'Why Us', href: '/why-us' },
    { label: 'Careers', href: '/careers' },
    { label: 'Press / Media', href: '/company' },
    { label: 'Blog / Insights', href: '/company' },
    { label: 'Sustainability', href: '/sustainability' },
  ],
  partners: [
    { label: 'Become a Warehouse Partner', href: '/storage' },
    { label: 'Become a Transport Partner', href: '/transport' },
    { label: 'Become a Supplier', href: '/wholesale' },
    { label: 'Become a Buyer', href: '/wholesale' },
  ],
  support: [
    { label: 'Contact Us', href: '/contact' },
    { label: 'Help Centre', href: '/contact' },
    { label: 'FAQs', href: '/contact' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-brand-700">
      <div className="container-page py-16 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-10 lg:gap-8">
          {/* Column 1: Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="mb-4">
              <img
                src="https://static.readdy.ai/image/51c2999678346de9bfca529f28d29556/a863f5d5d75fba3353a913ed2253dbc1.png"
                alt="FreshhLock"
                className="h-14 w-auto object-contain brightness-0 invert"
              />
            </div>
            <p className="text-sm text-paper-300/80 leading-relaxed mb-5">
              India's digital orchestration platform connecting the frozen food cold-chain — from warehouse to doorstep.
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-brand-600 hover:bg-accent-500 text-paper-300 hover:text-paper-50 transition-all cursor-pointer" aria-label="LinkedIn">
                <i className="ri-linkedin-fill text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-brand-600 hover:bg-accent-500 text-paper-300 hover:text-paper-50 transition-all cursor-pointer" aria-label="Twitter">
                <i className="ri-twitter-x-fill text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-brand-600 hover:bg-accent-500 text-paper-300 hover:text-paper-50 transition-all cursor-pointer" aria-label="YouTube">
                <i className="ri-youtube-fill text-sm"></i>
              </a>
            </div>
          </div>

          {/* Column 2: Solutions */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-paper-50 mb-4 tracking-wide">
              Solutions
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.solutions.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-sm text-paper-300/80 hover:text-accent-400 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3: Company */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-paper-50 mb-4 tracking-wide">
              Company
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.company.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-sm text-paper-300/80 hover:text-accent-400 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 4: Partners */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-paper-50 mb-4 tracking-wide">
              Partners
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.partners.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-sm text-paper-300/80 hover:text-accent-400 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 5: Support */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-paper-50 mb-4 tracking-wide">
              Support
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.support.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-sm text-paper-300/80 hover:text-accent-400 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-brand-600">
        <div className="container-page py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="flex flex-wrap items-center gap-x-6 gap-y-1 text-xs text-paper-400">
            <span>&copy; {new Date().getFullYear()} Freshhlock. All rights reserved.</span>
            <Link to="/privacy" className="hover:text-paper-300 transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-paper-300 transition-colors">Terms of Service</Link>
            <Link to="/cookies" className="hover:text-paper-300 transition-colors">Cookie Policy</Link>
          </div>
          <div className="flex items-center gap-4 text-xs text-paper-400">
            <span className="text-paper-500">Made for India&apos;s Cold Chain</span>
          </div>
        </div>
      </div>
    </footer>
  );
}